import { useEffect, useContext } from 'react';
import { StorageContext } from '../../context/StorageContext';
export function SessionWrapper(_a) {
    var children = _a.children;
    var cleanupSessions = useContext(StorageContext).cleanupSessions;
    useEffect(function () {
        var onBeforeUnload = function () {
            cleanupSessions();
        };
        window.addEventListener('beforeunload', onBeforeUnload);
        return function () {
            window.removeEventListener('beforeunload', onBeforeUnload);
        };
    }, []);
    return children;
}
